import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Bill_item_input } from '../../models/accounting/bill_item_input';
import { Statement } from '../../models/accounting/statement';
import { AccountItemsService } from '../../providers/account-items.service';
import { FixedInventoryService } from '../../providers/fixed-inventory.service';
import { CouponService } from '../../providers/coupon.service';

import { faSave, faUnlock }  from '@fortawesome/fontawesome-pro-regular';
import { Coupon } from '../../models/accounting/coupon';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import {AccountEntryView} from '../../models/account_entry_view';
import {PendingHorseShowEntryService} from '../../providers/pending-horse-show-entry.service';
import {Horse_show_entry} from '../../models/horse_show_entry';

@Component({
  standalone: false,
  selector: 'app-modal-edit-billing-items',
  templateUrl: './modal-edit-billing-items.component.html',
styleUrls:  ['./modal-edit-billing-items.component.css']
})
export class ModalEditBillingItemsComponent extends SmsAbstractAppPage implements OnInit {

  account_items_changed$: EventEmitter<Statement> = new  EventEmitter<Statement>();
  horse_show_entry: Horse_show_entry;
  bill_item_inputs: Bill_item_input[] = [];
  horse_show_name: string;
  faSave = faSave;
  event_has_request_only_items: boolean = false;
  offer_coupon_input: boolean = false;
  faUnlock = faUnlock;

  constructor(public activeModal: NgbActiveModal,
    private pendingHorseShowEntryService: PendingHorseShowEntryService,
    private accountItemsService: AccountItemsService,
    private fixedInventoryService: FixedInventoryService,
    private couponService: CouponService,
          ) {
  	super();
   }

  ngOnInit() {
  }

  setHorseShowEntry(entryView: AccountEntryView) {

    this.pendingHorseShowEntryService.get(entryView.entryId).then(horseShowEntry => {
      this.horse_show_entry = horseShowEntry;
      this.accountItemsService.getBillItemInputListForHorseShowEntryHavingType(horseShowEntry.horse_show_id, horseShowEntry.id, horseShowEntry.entry_type).then(bill_item_inputs => {
        this.bill_item_inputs = bill_item_inputs;
        this.bill_item_inputs.forEach((bill_item_input, i) => {
          if(bill_item_input.request_only){
            this.event_has_request_only_items = true;
          }
        });
        this.couponService.getCouponsForUserAtHorseShow(this.horse_show_entry.horse_show_id).then(coupons => {

          this.handleCouponUnlock(coupons);

        }).catch(error => {
          console.log(error);
        });

      }).catch(error => {
        this.handleError(error);
      });
    }).catch(error => {
      this.handleError(error);
    })

  }

  handleSaveChanges(){
  	this.accountItemsService.saveBillingItems(this.horse_show_entry.id, this.bill_item_inputs).then(statement => {
  		this.account_items_changed$.next(statement);
  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  private handleCouponUnlock(coupons: Coupon[]){
    coupons.forEach(coupon => {
      this.bill_item_inputs.forEach(input => {
        if(coupon.coupon_type_id == input.coupon_type_id && input.coupon_unlock){
          input.unlocked = true;
        }
      });
    });
  }

    handleSubmitCoupon(coupon_code: string){

    if(coupon_code != ""){
      this.couponService.submitCoupon_code(coupon_code).then(coupon => {
        let coupons: Coupon[] = [];
        coupons.push(coupon);
        this.handleCouponUnlock(coupons);
      }).catch(error => {
        this.handleError(error);
      });
    } else {
      this.handleError("Nothing entered...");
    }
  }

    confirmInventory(input: Bill_item_input){

    if(input.inventory_restricted){
      if(input.total_quantity_ordered > 0){
        this.fixedInventoryService.isRequestedQuantityAvailable(input.horse_show_id, input.code, input.total_quantity_ordered).then(can_order => {
          if(!can_order && (!input.coupon_unlock || !input.unlocked)){
            this.handleError("You are not able to order " + input.total_quantity_ordered + " " + input.code + " at this time. That quantity may exceed available inventory. Please try to add a smaller quantity or skip adding this item.");
            input.total_quantity_ordered = 0;
          }
        }).catch(error => {
          this.handleError(error);
        });
      }
    }

  }


}
